import LinkIcon from '@mui/icons-material/Link';
import React from 'react';
import { getExternalUrl, openInNewTab } from '../../../utils';
import { ContactCardBodyMediumLink, ContactCardItemContainer } from './styles';

type Props = {
    link: string;
};

export const ContactCardLinkItem = ({ link }: Props) => {
    return (
        <ContactCardItemContainer>
            <LinkIcon />
            <ContactCardBodyMediumLink
                href={getExternalUrl(link)}
                target='_blank'
                onClick={() => openInNewTab(link)}
            >
                {link}
            </ContactCardBodyMediumLink>
        </ContactCardItemContainer>
    );
};
